import QueryString from 'query-string'
import omit from 'lodash/omit'
import { Log, LogLevel } from './Log'

const configData = window.CS_CONFIG

export const IdpFetch = <T extends unknown>(idpRoute: string, queryStringObject?: Record<string, unknown>, isRaw?: boolean): Promise<T> => {
    const headers: Record<string, string> = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }

    const queryString = queryStringObject ? '?' + QueryString.stringify(omit(queryStringObject, 'sort')) : null
    const q = `${queryString || ''}`

    return fetch(configData.IdpBaseUrl + '/' + idpRoute + (q ? q : ''), headers)
        .then(res => {
            if (!res.ok) {
                res.text().then(t => {
                    Log(LogLevel.Error, `GET request ${configData.IdpBaseUrl + '/' + idpRoute + (q ? q : '')} failed with message ${t}`)
                })
                // eslint-disable-next-line no-console
                .catch(console.log)
                
                throw res
            }

            if (isRaw) return res.text()
            else return res.json()
        }) as Promise<T>
}

export const ApiPost = <T extends unknown>(idpRoute: string, queryStringObject?: Record<string, unknown>, object?: Record<string, unknown>): Promise<T> => {
    const queryString = queryStringObject ? '?' + QueryString.stringify(queryStringObject) : null

    const headers: Record<string, string> = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }

    const init = {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(object)
    }

    return fetch(configData.IdpBaseUrl + '/' + idpRoute + (queryString ? queryString : ''), init)
        .then(res => {
            if (res.status !== 200) {
                if (idpRoute.toLowerCase() !== 'log') {
                    res.text().then(t => {
                        Log(LogLevel.Error, `POST request ${configData.IdpBaseUrl + '/' + idpRoute + (queryString ? queryString : '')} failed with message ${t}`)
                    })
                    // eslint-disable-next-line no-console
                    .catch(console.log)
                }
                throw Error('There was an issue processing your request')
            }
            if (res.ok) {
                return res.text().then(t => {
                    return Promise.resolve(t.length > 0 ? JSON.parse(t) as T : true)
                })
            }
            if (idpRoute.toLowerCase() !== 'log') {
                Log(LogLevel.Error, `POST request ${configData.IdpBaseUrl + '/' + idpRoute + (queryString ? queryString : '')} failed to fully process`)
            }
            throw Error('Error processing API Post Request')
        }) as Promise<T>
}